import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-motivazione',
  templateUrl: './modal-motivazione.component.html'
})
export class ModalMotivazioneComponent {
  @Input() title: string = 'Motivazione';
  public motivazione = new FormControl('');

  constructor(public activeModal: NgbActiveModal) {}

  public confirm() {
    const value = (this.motivazione.value || '').toString().trim();
    if (!value) {
      return; 
    }
    this.activeModal.close(value);
  }

  public cancel() {
    this.activeModal.dismiss();
  }
}